/**
 * GameTweenConstants.ts
 */
export class GameTweenConstants {
}
GameTweenConstants.YOYO_DURATION = 0.2;
GameTweenConstants.GAME_SUMMARY_DURATION = 3000;
GameTweenConstants.AVAILABLE_WIN_DELAY = 500;
GameTweenConstants.AVAILABLE_WIN_SHOW_DURATION = 0.25;
GameTweenConstants.AVAILABLE_WIN_POPUP_DURATION = 1.5;
GameTweenConstants.AVAILABLE_WIN_FADE_DURATION = 0.1;
GameTweenConstants.REEL_STOP_INTERVAL_STANDARD = 250;
GameTweenConstants.REEL_STOP_INTERVAL_PURCHASE = 350;
GameTweenConstants.REEL_STOP_INTERVAL_SUSPENSE = 1000;
GameTweenConstants.BONUS_SPIN_INTERVAL = 0.6;
GameTweenConstants.BIG_WIN_TITLE_SCALE_DURATION = 0.45;
GameTweenConstants.FULL_HOUSE_TITLE_SCALE_DURATION = 0.45;
GameTweenConstants.SYMBOL_WIN_TITLE_SCALE_DURATION = 0.45;
GameTweenConstants.REEL_DURATION = 0.5;
GameTweenConstants.DEFAULT_OVERLAY_FADE_DURATION = 0.25;
GameTweenConstants.SCATTER_WIN_TITLE_SCALE_DURATION = 0.45;
GameTweenConstants.ENGINE_TIMING = 2.0;
//# sourceMappingURL=GameTweenConstants.js.map